import { Navigate, useParams } from "react-router";
import { useClientContext } from "../../../contexts/ClientContext";
import { getApiReportsUrl } from "../common/utilities/editReportUrl";
import { getAdminPortalEditApiReportUrl } from "../getAdminPortalReportUrls";
import RedirectToAdminPortal from "../RedirectToAdminPortal";

const EditRoot = () => {
  const { id } = useParams();
  const { clientCode } = useClientContext();

  if (id === undefined) {
    return <Navigate to={getApiReportsUrl(clientCode)} />;
  }

  return <RedirectToAdminPortal url={getAdminPortalEditApiReportUrl(clientCode, id)} />;
};
export default EditRoot;
